import React, { PureComponent, useCallback } from 'react';

import FormikProvider from '../../../shared/forms/formikProvider.component';
import Modal from '../../../shared/modals/modal.component';
import Form from '../../../shared/forms/form.component';

import schema from './currencyForm.schema';

import { Currency } from '../types';
import { SelectOption } from '../../../shared/types';

const ModalTitles = {
  ADD: 'Add Currency',
  EDIT: 'Edit Currency',
};

type AddEditCurrencyModalProps = {
  saveEntity: (
    entityToEdit: Currency,
    openForEdit: boolean,
    options: { callback: () => void, keepOpenAfterSaving: boolean }
  ) => void,
  hideModal: () => void,
  entityToEdit: Currency,
  openForEdit: boolean,
  isSavingEntity: boolean,
  isVisible: boolean,
  additionalData: {
    lookUpData: {
      enabledFlagOptions: SelectOption[]
    }
  }
};

type AddEditCurrencyModalState = {
  addAnother: boolean,
};


class AddEditCurrencyModal extends PureComponent<
  AddEditCurrencyModalProps,
  AddEditCurrencyModalState
> {
  state = {
    addAnother: false,
  };

  saveCurrency = (
    currency: Currency,
    { setSubmitting, resetForm }: { setSubmitting: (isSubmitting: boolean) => void, resetForm: () => void }
  ) => {
    const { saveEntity, openForEdit } = this.props;
    const { addAnother } = this.state;

    this.setState({ addAnother: false }, () => {
      saveEntity(currency, openForEdit, { callback: resetForm, keepOpenAfterSaving: addAnother });
      setSubmitting(false);
    });
  };

  renderModal = ({ formik, schema }: any ) => {
    const {
      openForEdit,
      hideModal,
      isVisible,
      isSavingEntity,
      additionalData,
    } = this.props;

    const submit = useCallback(() => {
      this.setState({
        addAnother: false,
      }, () => formik.handleSubmit());
    }, [formik]);

    const submitAndAddAnotherAction = useCallback(() => {
      this.setState({
        addAnother: true,
      }, () => formik.handleSubmit());
    }, [formik]);

    const reset = useCallback(() => {
      hideModal();
      formik.resetForm();
    }, [formik, hideModal]);

    return (
      <Modal
        className="add-edit-currency-modal"
        title={openForEdit ? ModalTitles.EDIT : ModalTitles.ADD}
        closeAction={reset}
        dismissText="Cancel"
        dismissAction={reset}
        submitText="Save"
        submitAction={submit}
        isSubmitting={formik.isSubmitting || isSavingEntity}
        submitAndAddAnotherAction={!openForEdit ? submitAndAddAnotherAction : null}
        submitAndAddAnotherText="Save and Add Another"
        isVisible={isVisible}
      >
        <Form
          formik={formik}
          schema={schema}
          openForEdit={openForEdit}
          formContext={additionalData.lookUpData}
        />
      </Modal>
    );
  };

  render() {
    const { entityToEdit } = this.props;

    return (
      <FormikProvider
        schema={schema}
        entityToEdit={entityToEdit}
        onSubmit={this.saveCurrency as any}
        render={this.renderModal}
      />
    );
  }
}

export default AddEditCurrencyModal;
